var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-viewer"},[_c('img',{directives:[{name:"img",rawName:"v-img:group",value:(1),expression:"1",arg:"group"}],ref:"image",staticClass:"img-viewer__zoomable-image",attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }